import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { brandColors } from '../../theme';

export const PrimaryCTA: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        background: `linear-gradient(135deg, ${brandColors.indigo} 0%, ${brandColors.blue} 100%)`,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: brandColors.white,
              fontWeight: 600,
              mb: 3,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            }}
          >
            Ready to Access Premium Market Intelligence?
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: brandColors.white,
              fontWeight: 400,
              mb: 5,
              opacity: 0.95,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Browse our complete market catalog and find the insights you need to make informed decisions.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/global-market-reports')}
              sx={{
                backgroundColor: brandColors.gold,
                color: brandColors.indigo,
                px: 6,
                py: 2,
                fontSize: '1.25rem',
                fontWeight: 700,
                borderRadius: 3,
                textTransform: 'none',
                boxShadow: '0 6px 20px rgba(245, 168, 0, 0.4)',
                '&:hover': {
                  backgroundColor: '#FFC344',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 24px rgba(245, 168, 0, 0.5)',
                },
                transition: 'all 0.3s ease',
                minWidth: 250,
              }}
            >
              Browse All Markets
            </Button>

          </Box>
        </Box>
      </Container>
    </Box>
  );
};